import { Icon, IconColor, IconID, IconSize, } from '@thoughtspot/radiant-react/widgets/icon';
import React from 'react';
export const ColumnControlButton = ({ onClickHandler }) => {
    return (React.createElement("div", { className: "bkv2-options", onClick: onClickHandler },
        React.createElement(Icon, { id: IconID.MORE, size: IconSize.LARGE, color: IconColor.BLACK })));
};
//# sourceMappingURL=pivot-button.js.map